// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"68f981682768d842c004","655":"c315258cd2549914b1d1"}[chunkId] + ".js";
};